/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Space } from "antd";
import { useEffect, useState } from "react";
import DownloadIcon from "../../assets/icons/DownloadIcon";
import { API_URL } from "../../constants/apiUrl";
import { PAYROLL_API } from "../../constants/constants";
import { useUploadGrossSalaryMutation } from "../../features/payrollSetting/payrollSettingApi";
import useDownloadEmployeeXlsx from "../../hooks/useDownloadExcelWithApi";
import useError from "../../hooks/useError";
import useModal from "../../hooks/useModal";
import { toast } from "../../lib/toast";
import { ModalComponentProps } from "../../types";
import UploadExcelModal from "../common/UploadExcelModal";
import SuccessModal from "../Report/SuccessModal";

export default function GrossSalaryModal({
  open,
  handleClose,
}: ModalComponentProps) {
  // const navigate = useNavigate();
  const { loading: excelLoading, downloadXlsx } = useDownloadEmployeeXlsx();
  const [uploadEmployeeData, { isLoading, isError, error, isSuccess }] =
    useUploadGrossSalaryMutation();
  useError(isError, error, "Upload gross salary fail");
  const [formData, setFormData] = useState<FormData | null>(null);
  const {
    handleOpen,
    open: childOpen,
    handleClose: childClose,
  } = useModal<undefined, "SUCCESS">();

  const handleDownload = () => {
    downloadXlsx(
      PAYROLL_API + API_URL.downloadGrossSalary,
      {},
      "employee-gross-salary",
      "formattedEmployees",
      (salary: any) => {
        return {
          "Employee Id": salary?.employee_id ?? "-",
          "Employee Name": salary?.name ?? "-",
          "Employee Email": salary?.email ?? "-",
          "Gross Salary": salary?.gross_salary ?? "-",
        };
      }
    );
  };

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Gross salary updated successfully");
      handleOpen({ type: "SUCCESS" });
      // if (data?.data?.success === "success") {
      //   navigate("/admin/task-queue");
      // }
      // return handleClose();
    }
  }, [handleClose, isSuccess]);

  return (
    <>
      <UploadExcelModal
        open={open}
        handleClose={handleClose}
        isLoading={false}
        handler={setFormData}
        title="Update Gross Salary Data in Bulk"
        warningText="First download the active Employee information's and upload it after editing desired information's."
        downloadLink={"/employee-gross-salary.xlsx"}
        footer={
          <Space size={12}>
            {childOpen?.type === "SUCCESS" && (
              <SuccessModal
                type="queue"
                open={childOpen?.open}
                handleClose={childClose}
              />
            )}
            <Button
              className="outline-button-primary modal-button"
              icon={<DownloadIcon />}
              loading={excelLoading}
              onClick={handleDownload}
            >
              Download Existing Data
            </Button>
            <Button
              className="modal-button"
              type="primary"
              loading={isLoading}
              onClick={() => uploadEmployeeData(formData)}
            >
              Upload
            </Button>
          </Space>
        }
      />
    </>
  );
}
